import {
  ToastErrorMsg,
  ToastSuccessMsg,
  ToastWarningMsg,
} from "@/components/Toast";
import { toast } from "react-toastify";

export const toastSuccess = (message: string) => {
  toast(ToastSuccessMsg({ message }), {
    type: "success",
  });
};

export const toastError = (message: string) => {
  toast(ToastErrorMsg({ message }), {
    type: "error",
  });
};

export const toastWarning = (message: string) => {
  toast(ToastWarningMsg({ message }), {
    type: "warning",
  });
};
